import axios from 'axios'
import request from '../helpers/authorizateRequest'

const BASE_URL = '/brand-support-overview/v1'

const ENDPOINTS = {
    summary: `${BASE_URL}/summary`,
    settings: `${BASE_URL}/settings`,
    availableCompanies: `${BASE_URL}/available-companies`,
    companies: `${BASE_URL}/settings/companies`,
    order: `${BASE_URL}/settings/order`,
}

function body(response) {
    return response.data
}

export default {
    createCancelSource() {
        return axios.CancelToken.source()
    },

    isCancel(error) {
        return axios.isCancel(error)
    },

    summary(cancelToken) {
        return request.get(ENDPOINTS.summary, { cancelToken }).then(body)
    },

    settings(cancelToken) {
        return request.get(ENDPOINTS.settings, { cancelToken }).then(body)
    },

    availableCompanies(params, cancelToken) {
        return request.get(ENDPOINTS.availableCompanies, { params, cancelToken }).then(body)
    },

    addCompany(companyId, expectedVersion) {
        return request.post(ENDPOINTS.companies, {
            company_id: companyId,
            expected_version: expectedVersion,
        }).then(body)
    },

    removeEntry(entryId, expectedVersion) {
        return request.delete(`${ENDPOINTS.companies}/${encodeURIComponent(entryId)}`, {
            params: { expected_version: expectedVersion },
        }).then(body)
    },

    // beforeEntryId === null moves the entry to the end of the list.
    moveEntry(entryId, beforeEntryId, expectedVersion) {
        return request.patch(ENDPOINTS.order, {
            entry_id: entryId,
            before_entry_id: beforeEntryId,
            expected_version: expectedVersion,
        }).then(body)
    },
}
